export default __webpack_public_path__ + "static/Group 67-90f69d26619c24cc5d1ac072aaff33bc.jpg";